<template>
<!-- 小鹅通反馈统计 -->
    <div class="el-card  pd20">
        <!-- add---新增 -->
        <div class="add-box">
            <el-button style="margin-left:10px;" type="infor" @click="$router.go(-1)" size="medium">返回</el-button>
            <el-button style="margin-left:10px;" type="primary" @click="exportExcelHandle" size="medium">导出</el-button>
        </div>
        <!--  -->
        <div class="el-card  pd20 content">
            <el-table :data="list" border style="width: 100%">
                <el-table-column type="index" width="50" label="序号"></el-table-column>
                <el-table-column prop="id" label="订单ID" ></el-table-column>
                <el-table-column prop="uid" label="用户ID" ></el-table-column>
                <el-table-column prop="price" label="金额" ></el-table-column>
                <el-table-column  label="付款时间" >
                    <template slot-scope="scope">
                        {{dateFmt(scope.row.pay_time)}}
                    </template>
                </el-table-column>
                <el-table-column prop="nickname" label="用户昵称" ></el-table-column>
                <el-table-column  label="用户头像" >
                    <template  slot-scope="scope">
                        <div v-if="scope.row.headimgurl" class="userinfo">
                            <img :src="scope.row.headimgurl" alt="">
                        </div>
                        
                    </template>
                </el-table-column>
                <el-table-column  label="课程期次" >
                    <template  slot-scope="scope">
                        {{scope.row.bigcourse+scope.row.course}}
                    </template>
                </el-table-column>
                <el-table-column prop="share_user_id" label="推荐人用户id" ></el-table-column>
                <el-table-column prop="share_user_nickname" label="推荐人昵称" ></el-table-column>
                <el-table-column  label="推荐人头像" >
                    <template  slot-scope="scope">
                        <div v-if="scope.row.share_user_headimgurl" class="userinfo">
                            <img :src="scope.row.share_user_headimgurl" alt="">
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="workage" label="工作年限" ></el-table-column>
                <el-table-column prop="career" label="行业" ></el-table-column>
                <el-table-column prop="job" label="职能" ></el-table-column>
                <el-table-column prop="job_grade" label="职级" ></el-table-column>
                <el-table-column prop="look" label="熟悉度" ></el-table-column>
            </el-table>
        </div>
    </div>
</template>

<script>
import { statDetail } from "@/api/operating";
import { dateFormat,exportExcel,deepCopy } from "@/utils/tools";
export default {
    data() {
        return{
            list:[]
        }
    },
    methods:{
        //导出的方法
        exportExcelHandle() {
          let h = [
              '订单ID',
              '用户ID',
              '金额',
              '用户昵称',
              '用户头像',
              '课程',
              '期次',

              '推荐人用户id',
              '推荐人昵称',
              '推荐人头像',
              '工作年限',
              '行业',
              '职能',
              '职级',
              '熟悉度'
          ];
          let b =  [
            'id',
            'uid',
            'price',
            'nickname',
            'headimgurl',
            'bigcourse',
            'course',

            'share_user_id',
            'share_user_nickname',
            'share_user_headimgurl',
            'workage',
            'career',
            'job',
            'job_grade',
            'look'
          ];
          
          statDetail({
              id:this.$route.query.id
          }).then((res)=>{
              let list = res.list;  //把data里的tableData存到list
              exportExcel(h,b,list,'小鹅通直播统计详情')
          })
            
        },
        // 时间戳转换时间
        dateFmt(d){
            return dateFormat('yyyy-MM-dd hh:mm:ss',new Date(d*1000))
        },
        // 初始化方法
        pullData(){
            this.$showLoading();
            statDetail({
                id:this.$route.query.id
            }).then((data)=>{
                this.list = data.list;
                this.pages = data.pager;

                this.$hideLoading();
            }).catch((err)=>{
                this.$hideLoading();
            });
        }
    },
    created(){
        this.pullData();
    }
}
</script>

<style lang="scss" scoped>
.add-box{
    margin-bottom: 20px;
    display: flex;
}
.content{
    padding: 20px;
}
.pages{
  text-align: right;
  margin-top: 30px;
}
.search{
    margin-left: auto;
    text-align: right;
}
.search-child{
    margin-left: 20px;
}
.userinfo{
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    img{
        width: 40px;
        height: 40px;
        border-radius: 50%;
        margin-right: 15px;
    }
}
</style>
